import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  addCourse,
  deleteCourse,
  getCourseCategories,
  getCourses,
  updateCourse,
} from "../../Services/HomeService";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

const ManageCourse = () => {
  const [courseCategories, setCourseCategories] = useState([]);
  const [fetchCourseCategoriesLoading, setFetchCourseCategoriesLoading] =
    useState(false);
  const [courses, setCourses] = useState([]);
  const [fetchCoursesLoading, setFetchCoursesLoading] = useState(false);

  const [createCourseObject, setCreateCourseObject] = useState({
    degreeName: "",
    categoryId: "",
  });
  const [createCourseLoading, setCreateCourseLoading] = useState(false);

  const [editCourse, setEditCourse] = useState(null);
  const [updateCourseLoading, setUpdateCourseLoading] = useState(false);

  const fetchCourseCategories = async () => {
    try {
      setFetchCourseCategoriesLoading(true);
      const res = await getCourseCategories();
      console.log("fetched Course Categories", res?.data);
      if (res?.status) {
        setCourseCategories(res?.data);
        setFetchCourseCategoriesLoading(false);
      } else {
        toast.error("Error while Fetching Course Categories Data");
        setFetchCourseCategoriesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Course Categories Data");
      console.error("Error fetching Course Categories:", error);
      setFetchCourseCategoriesLoading(false);
    }
  };

  const fetchCourses = async () => {
    try {
      setFetchCoursesLoading(true);
      const res = await getCourses();
      console.log("fetched Courses", res?.data);
      if (res?.status) {
        setCourses(res?.data);
        setFetchCoursesLoading(false);
      } else {
        toast.error("Error while Fetching Courses Data");
        setFetchCoursesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Courses Data");
      console.error("Error fetching Courses:", error);
      setFetchCoursesLoading(false);
    }
  };

  useEffect(() => {
    fetchCourseCategories();
    fetchCourses();
  }, []);

  const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
  };
  const customStyles = {
    headCells: {
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        color: "#333",
      },
    },
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      center: true,
    },
    {
      name: "Course Category",
      selector: (row) => row?.category?.name,
      sortable: true,
      center: true,
    },
    {
      name: "Course Name",
      selector: (row) => row?.degreeName,
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <span title="Edit">
            <i
              onClick={() => {
                handleUpdateClick(row);
              }}
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          {/* <span title="Delete">
            <i
              onClick={() => {
                handleDelete(row?._id);
              }}
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span> */}
        </>
      ),
    },
  ];

  const handleCreateCourse = async (e) => {
    e?.preventDefault();
    if (!createCourseObject?.degreeName || !createCourseObject?.categoryId) {
      toast.error("Please Enter All Fields");
      return;
    }
    try {
      setCreateCourseLoading(true);
      const res = await addCourse(createCourseObject);
      console.log("Course Add Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setCreateCourseObject((prev) => ({ ...prev, degreeName: "" }));
        fetchCourses();
        setCreateCourseLoading(false);
      } else {
        toast.error(res?.message);
        setCreateCourseLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add Course.");
      console.error("Error adding Course:", error);
      setCreateCourseLoading(false);
    }
  };

  const handleUpdateClick = (row) => {
    setEditCourse(row);
  };

  const handleCancel = () => {
    setEditCourse(null);
  };

  const handleUpdateCourse = async (e) => {
    e?.preventDefault();
    if (!editCourse?.degreeName || !editCourse?.category?._id) {
      return toast.error("Enter All Fields to Update");
    }

    try {
      setUpdateCourseLoading(true);
      const res = await updateCourse(editCourse?._id, {
        degreeName: editCourse?.degreeName,
        categoryId: editCourse?.category?._id,
      });
      console.log("Category update Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setEditCourse(null);
        fetchCourses();
        setUpdateCourseLoading(false);
      } else {
        toast.error(res?.message);
        setUpdateCourseLoading(false);
      }
    } catch (error) {
      toast.error("Failed to Update Course.");
      console.error("Error Updating Course:", error);
      setUpdateCourseLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Course?",
      text: "Are you sure you want to delete this Course?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        await deleteCourse(id);
        Swal.fire("Deleted!", "Course has been deleted.", "success");
        fetchCourses();
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Course.", "error");
      }
    }
  };

  return (
    <>
      {!editCourse && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <div style={headLineStyle} className="page-headline">
              Manage Course
            </div>
            <section className="chartBox_area">
              <form
                onSubmit={(e) => {
                  handleCreateCourse(e);
                }}
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      Course Category<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      onChange={(e) => {
                        setCreateCourseObject((prev) => ({
                          ...prev,
                          categoryId: e?.target?.value,
                        }));
                      }}
                    >
                      <option value="">
                        -------- Select Course Category --------
                      </option>
                      {fetchCourseCategoriesLoading ? (
                        <option>Loading...</option>
                      ) : courseCategories?.length === 0 ? (
                        <option>No Course Category Found</option>
                      ) : (
                        courseCategories?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.name}
                            </option>
                          );
                        })
                      )}
                    </select>
                  </div>
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      Course Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="form-control"
                      value={createCourseObject?.degreeName}
                      onChange={(e) =>
                        setCreateCourseObject((prev) => ({
                          ...prev,
                          degreeName: e.target.value,
                        }))
                      }
                      placeholder="Enter Course Name"
                      required
                    />
                  </div>
                </div>
                <div className=" d-flex justify-content-center">
                  <button
                    disabled={createCourseLoading}
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                    }}
                  >
                    {createCourseLoading ? "Loading..." : "Add Course"}
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}
      {!editCourse && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <section className="chartBox_area">
              <DataTable
                data={courses}
                columns={columns}
                pagination
                responsive
                highlightOnHover
                customStyles={customStyles}
                progressPending={fetchCoursesLoading}
              />
            </section>
          </div>
        </div>
      )}

      {editCourse && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <div style={headLineStyle} className="page-headline">
              Update Course
            </div>
            <section className="chartBox_area">
              <form
                onSubmit={(e) => {
                  handleUpdateCourse(e);
                }}
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      Course Category<span className="text-danger">*</span>
                    </label>
                    <select
                      value={editCourse?.category?._id}
                      className="form-control"
                      onChange={(e) => {
                        setEditCourse((prev) => ({
                          ...prev,
                          category: {
                            ...prev?.category,
                            _id: e?.target?.value,
                          },
                        }));
                      }}
                    >
                      <option value="">
                        -------- Select Course Category --------
                      </option>
                      {fetchCourseCategoriesLoading ? (
                        <option>Loading...</option>
                      ) : courseCategories?.length === 0 ? (
                        <option>No Course Category Found</option>
                      ) : (
                        courseCategories?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.name}
                            </option>
                          );
                        })
                      )}
                    </select>
                  </div>
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      Course Name<span className="text-danger">*</span>
                    </label>
                    <input
                      value={editCourse?.degreeName}
                      type="text"
                      id="name"
                      className="form-control"
                      onChange={(e) =>
                        setEditCourse((prev) => ({
                          ...prev,
                          degreeName: e.target.value,
                        }))
                      }
                      placeholder="Enter Course Name"
                      required
                    />
                  </div>
                </div>
                <div
                  className=" d-flex justify-content-center"
                  style={{ gap: "15px" }}
                >
                  <button
                    disabled={createCourseLoading}
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                    }}
                  >
                    {updateCourseLoading ? "Loading..." : "Update Course"}
                  </button>
                  <button
                    onClick={() => {
                      handleCancel();
                    }}
                    disabled={updateCourseLoading}
                    type="button"
                    className="btn mt-3"
                    style={{
                      background: "#f77754",
                      borderRadius: "13px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default ManageCourse;
